export default "__VITE_ASSET__ca2cd416__"